const EXPLICIT_TIMEZONE_PATTERN = /(?:Z|[+-]\d{2}:?\d{2})$/i;

export function hasExplicitTimezone(value) {
  return typeof value === "string" && EXPLICIT_TIMEZONE_PATTERN.test(value.trim());
}
